import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_virtual } from '@shared/dto/grid2d_virtual/DTO__grid2d_virtual';
import { useVirtualizer } from '@tanstack/react-virtual';
import { useRef } from 'react';
import { HOOK_ROW1D__masonry_cell_widths } from './HOOK_ROW1D__masonry_cell_widths';

export function HOOK_ROW1D__float_virtualizer(
  grid2d_virtual: DTO__grid2d_virtual,
  grid2d: DTO__grid2d,
  //
  ref_row1d: HTMLDivElement,
  ui_grid2d_cells_sort_newest_first: boolean,
  max_side: number,
) {
  const ref_item_heights = useRef<number[]>([]);

  let virtualizer = useVirtualizer({
    count: grid2d.total_cells_amount,
    getScrollElement: () => ref_row1d,
    estimateSize: i => ref_item_heights.current[i],
    overscan: grid2d_virtual.total_columns * 10,
    horizontal: true,
    gap: CONSTANTS__client.FLOAT_GRID_GAP,
  });

  const { try_recalculate_item_width } = HOOK_ROW1D__masonry_cell_widths({
    grid2d_virtual,
    ref_item_heights,
    grid2d,
    ui_grid2d_cells_sort_newest_first,
    max_side,
    virtualizer,
  });

  return { virtualizer, try_recalculate_item_width };
}
